const fieldOptionPriceDirective = function () {
    return {
        restrict: 'E',
        scope: {
            price: '=',
        },
        controller($scope) {
            $scope.absPrice = $scope.price ? Math.abs($scope.price) : null;
        },
        template: function () {
            return `
              <span ng-if="price && price < 0"
                  class="label label-success">- {{ absPrice | currencySymbol }}</span>

              <span ng-if="price && price > 0"
                  class="label label-warning">+ {{ price | currencySymbol }}</span>`;
        },
    };
};

module.exports = fieldOptionPriceDirective;
